import {Component, Input, OnInit} from '@angular/core';
import {QuotationService} from '../../services/quotation-service/quotation.service';
import {LeadService} from '../../services/lead-service/lead.service';
import {WebLeadType} from '../../model/leads/WebLeadType';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  public errorMessage = null;
  @Input() activationJourney = false;

  constructor(private quotationService: QuotationService,
              private leadService: LeadService) {
  }

  ngOnInit() {
    this.errorMessage = this.quotationService.fallBackError;

    if (this.quotationService.errorMessage !== null) {
      this.errorMessage = this.quotationService.errorMessage;
      if (this.leadService.updateLead(WebLeadType.WEB_LEAD_3)) {
        this.leadService.updateLead(WebLeadType.WEB_LEAD_3, null, null,
          this.quotationService.errorCode + ':' + this.errorMessage.replace(/\n/g, ''),
          this.quotationService.campaign, this.quotationService.quotationRequest.medium)
          .subscribe((result) => {
          });
      }
    }

    this.quotationService.scrollToTop();
  }

}
